import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  // 车展大会 “双胞胎”页面
  {
    path: "/auto-assembly",
    name: "auto-assembly",
    component: () => import("../pages/auto-assembly/index.vue"),
    meta: {
      title: "2021年汽车数字化研讨大会",
      routerTitle: "2021年汽车数字化研讨大会",
    },
  },
  // 车展大会 “双胞胎”页面 报名详情页面
  {
    path: "/auto-assembly/meeting-info",
    name: "detail",
    component: () => import("../pages/auto-assembly/meeting/Meeting-info.vue"),
    meta: {
      title: "2021年汽车数字化研讨大会/活动详情页",
      routerTitle: "2021年汽车数字化研讨大会/活动详情页",
    },
  },
  //解决方案
  {
    path: "/solution",
    name: "solution",
    component: () => import("../pages/solution/Solution.vue"),
    meta: {
      title: "解决方案",
      routerTitle: "解决方案",
    },
  },
  {
    path: "/tech-create",
    name: "tech-create",
    component: () => import("../pages/solution/Tech-create.vue"),
    meta: {
      title: "技术创新",
      routerTitle: "技术创新",
    },
  },
  {
    path: "/technical-column",
    name: "technical-column",
    component: () => import("../pages/solution/Technical-column.vue"),
    meta: {
      title: "技术专栏",
      routerTitle: "技术专栏",
    },
  },
  {
    path: "/application",
    name: "application",
    component: () => import("../pages/solution/Application.vue"),
    meta: {
      title: "行业应用",
      routerTitle: "行业应用",
    },
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("../pages/solution/about-us/About-us.vue"),
    meta: {
      title: "关于我们",
      routerTitle: "关于我们",
    },
  },
  {
    path: "/digitizing-app",
    name: "digitizing-app",
    component: () => import("../pages/solution/about-us/Digitizing-app.vue"),
    meta: {
      title: "西门子数字化工业软件",
      routerTitle: "西门子数字化工业软件",
    },
  },
  {
    path: "/innovation-center",
    name: "innovation-center",
    component: () => import("../pages/solution/about-us/Innovation-center.vue"),
    meta: {
      title: "成都创新中心",
      routerTitle: "成都创新中心",
    },
  },
  {
    path: "/online-advisory",
    name: "online-advisory",
    component: () => import("../pages/service-center/Online-advisory.vue"),
    meta: {
      title: "在线咨询",
      routerTitle: "在线咨询",
    },
  },
  {
    path: "/book-visit",
    name: "book-visit",
    component: () => import("../pages/service-center/Book-visit.vue"),
    meta: {
      title: "预约参观",
      routerTitle: "预约参观",
    },
  },
  {
    path: "/user-center",
    name: "user-center",
    component: () => import("../pages/service-center/user-center/User-center.vue"),
    meta: {
      title: "会员中心",
      routerTitle: "会员中心",
    },
  },
  {
    path: "/user-regist",
    name: "user-regist",
    component: () => import("../pages/service-center/user-center/User-regist.vue"),
    meta: {
      title: "会员注册",
      routerTitle: "会员注册",
    },
  },
  //公共页面
  {
    path: "/Article",
    name: "detail",
    component: () => import("../pages/public-pages/Article.vue"),
    meta: {
      title: "文章详情",
      // routerTitle:"文章详情"
    },
  },
  {
    path: "/leave-message",
    name: "leave-message",
    component: () => import("../pages/public-pages/Leave-message.vue"),
    meta: {
      title: "在线留言",
      routerTitle: "在线留言",
    },
  },
  {
    path: "/regist-form",
    name: "detail",
    component: () => import("../pages/public-pages/Regist-form.vue"),
    meta: {
      title: "填写信息",
      routerTitle: "填写信息",
    },
  },
  {
    path: "/video-view",
    name: "detail",
    component: () => import("../pages/public-pages/Video-view.vue"),
    meta: {
      title: "视频详情页",
      // routerTitle:"视频详情页"
    },
  },
  {
    path: "/label-list",
    name: "detail",
    component: () => import("../pages/public-pages/Label-list.vue"),
    meta: {
      title: "标签列表页",
      // routerTitle:"标签列表页"
    },
  },
  //在线学堂
  {
    path: "/former-resource-center",
    name: "former-resource-center",
    component: () => import("../pages/online-school/resource-center/former-Resource-center.vue"),
    meta: {
      title: "资源中心",
      routerTitle: "资源中心",
    },
  },
  {
    path: "/resource-center",
    name: "resource-center",
    component: () => import("../pages/online-school/resource-center/Resource-center.vue"),
    meta: {
      title: "资源中心",
      routerTitle: "资源中心",
    },
  },
  {
    path: "/resource-list",
    name: "resource-list",
    component: () => import("../pages/online-school/resource-center/Resource-list.vue"),
    meta: {
      title: "资源列表页",
      routerTitle: "资源列表页",
    },
  },
  {
    path: "/resource-search",
    name: "resource-search",
    component: () => import("../pages/online-school/resource-center/Resource-search.vue"),
    meta: {
      title: "资源搜索",
      routerTitle: "资源搜索",
    },
  },
  {
    path: "/search-result",
    name: "detail",
    component: () => import("../pages/online-school/resource-center/Search-result.vue"),
    meta: {
      title: "搜索",
      routerTitle: "搜索",
    },
  },
  {
    path: "/resource-details",
    name: "detail",
    component: () => import("../pages/online-school/resource-center/Resource-details.vue"),
    meta: {
      title: "资源详情页",
      routerTitle: "资源详情页",
    },
  },
  {
    path: "/file-preview",
    name: "detail",
    component: () => import("../pages/online-school/resource-center/file-preview.vue"),
    meta: {
      title: "预览",
      routerTitle: "预览",
    },
  },

  {
    path: "/meeting-info",
    name: "detail",
    component: () => import("../pages/online-school/online-meeting/Meeting-info.vue"),
    meta: {
      title: "活动详情页",
      routerTitle: "活动详情页",
    },
  },
  {
    path: "/meeting-info1",
    name: "detail",
    component: () => import("../pages/online-school/online-meeting/Meeting-info1.vue"),
    meta: {
      title: "视频播放页",
      routerTitle: "视频播放页",
    },
  },
  {
    path: "/online-meeting",
    name: "online-meeting",
    component: () => import("../pages/online-school/online-meeting/Online-meeting.vue"),
    meta: {
      title: "线上研讨会",
      routerTitle: "线上研讨会",
      keepAlive: true,
    },
  },
  {
    path: "/class-info",
    name: "detail",
    component: () => import("../pages/online-school/online-class/Class-info.vue"),
    meta: {
      title: "课程详情页",
      routerTitle: "课程详情页",
    },
  },
  {
    path: "/online-class",
    name: "online-class",
    component: () => import("../pages/online-school/online-class/Online-class.vue"),
    meta: {
      title: "在线学堂",
      routerTitle: "在线学堂",
    },
  },
  // 九宫格
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("../pages/grid/Contact-us.vue"),
    meta: {
      title: "联系我们",
      routerTitle: "联系我们",
    },
  },
  {
    path: "/exhibition-sign",
    name: "exhibition-sign",
    component: () => import("../pages/grid/Exhibition-sign.vue"),
    meta: {
      title: "展会报名",
      routerTitle: "展会报名",
    },
  },
];
const router = new Router({
  // base: process.env.BASE_URL,
  routes
})
const detailRouter = ['detail', "sort"]

//路由守卫  设置当前页面的title
// router.beforeEach((to, form, next) => {
//   console.log(to.name, to.path);
//   var result = detailRouter.some(item => {
//     return item == to.name;
//   })
//   if (!result) {
//     Vue.prototype.cm.emit({
//       type: 'browse',
//       viewTitle: to.meta.routerTitle
//     });
//   }
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js